import { lazy } from "react";
import {
  Car,
  BarChart2,
  Settings,
  ClipboardList,
  CarFront,
  ChartColumnBig,
} from "lucide-react";
import { App, AppKey } from "./types/app";

export const APPS: Record<AppKey, App> = {
  cleanup: {
    key: "cleanup",
    name: "Cleanup",
    basePath: "/cleanup",
    plan: "Enterprise",
    routes: [
      {
        path: "/cleanup",
        component: lazy(() => import("@/app/apps/cleanup/page")),
        nav: { title: "Cleanup", icon: Car },
        permission: { entityType: "cleanup", action: "view_cleanup" },
      },
      {
        path: "/cleanup/analytics",
        component: lazy(() => import("@/app/apps/cleanup/analytics/page")),
        nav: { title: "Analytics & Reporting", icon: BarChart2 },
        permission: { entityType: "cleanup", action: "view_analytics" },
      },
      {
        path: "/cleanup/admin",
        component: lazy(() => import("@/app/apps/cleanup/admin/page")),
        nav: { title: "Administration", icon: Settings },
        permission: {
          entityType: "cleanup",
          action: "manage_cleanup",
          group: "superadmin",
        },
      },
      {
        path: "/cleanup/vehicle-profile",
        component: lazy(
          () => import("@/app/apps/cleanup/vehicle-profile/page")
        ),
        nav: { title: "Vehicle Profile", icon: CarFront },
        permission: { entityType: "cleanup", action: "view_vehicle" },
      },
      {
        path: "/cleanup/create",
        component: lazy(() => import("@/app/apps/cleanup/create/page")),
        permission: { entityType: "cleanup", action: "add_cleanup" },
      },
    ],
  },
  getready: {
    key: "getready",
    name: "Get Ready",
    basePath: "/get-ready",
    plan: "Enterprise",
    routes: [
      {
        path: "/get-ready",
        component: lazy(() => import("@/app/apps/get-ready/page")),
        nav: { title: "Get Ready", icon: Car },
        permission: { entityType: "getready", action: "view_getready" },
      },
      {
        path: "/get-ready/management",
        component: lazy(() => import("@/app/apps/get-ready/management/page")),
        nav: { title: "Management", icon: Settings },
        permission: {
          entityType: "getready",
          action: "manage_getready",
          group: "service_advisor",
        },
      },
      {
        path: "/get-ready/analytics",
        component: lazy(() => import("@/app/apps/get-ready/analytics/page")),
        nav: { title: "Analytics", icon: BarChart2 },
        permission: { entityType: "getready", action: "view_analytics" },
      },
      {
        path: "/get-ready/logs",
        component: lazy(
          () => import("@/app/apps/get-ready/getready-logs/page")
        ),
        nav: { title: "Logs", icon: ClipboardList },
        permission: { entityType: "getready", action: "view_logs" },
      },
      {
        path: "/get-ready/create",
        component: lazy(() => import("@/app/apps/get-ready/create/page")),
        permission: { entityType: "getready", action: "add_getready" },
      },
    ],
  },
  garageregister: {
    key: "garageregister",
    name: "Garage Register",
    basePath: "/garage-register",
    plan: "Enterprise",
    routes: [
      {
        path: "/garage-register",
        component: lazy(() => import("@/app/apps/garage-register/page")),
        nav: { title: "Garage Register", icon: Car },
        permission: { entityType: "garageregister", action: "view_vehicle" },
      },
      {
        path: "/garage-register/reporting",
        component: lazy(
          () => import("@/app/apps/garage-register/reporting/page")
        ),
        nav: { title: "Reporting", icon: BarChart2 },
        permission: { entityType: "garageregister", action: "view_omvic" },
      },
      {
        path: "/garage-register/analytics",
        component: lazy(
          () => import("@/app/apps/garage-register/analytics/page")
        ),
        nav: { title: "Analytics", icon: ChartColumnBig },
        permission: { entityType: "garageregister", action: "view_omvic" },
      },
      {
        path: "/garage-register/logs",
        component: lazy(
          () => import("@/app/apps/garage-register/garage-register-logs/page")
        ),
        nav: { title: "Logs", icon: ClipboardList },
        permission: { entityType: "garageregister",   action: [
      "view_garage_stock_history",
      "view_garage_management_history"
    ] },
      },{
        path: "/garage-register/management",
        component: lazy(
          () => import("@/app/apps/garage-register/management/page")
        ),
        nav: { title: "Management", icon: Settings },
        permission: {
          entityType: "garageregister",
          action: "manage_garageregister",
          // group: "service_advisor",
        },
      },
      {
        path: "/garage-register/stock-in",
        component: lazy(
          () => import("@/app/apps/garage-register/stock-in/page")
        ),
        permission: { entityType: "garageregister", action: "add_vehicle" },
      },
      {
        path: "/garage-register/stock-out",
        component: lazy(
          () => import("@/app/apps/garage-register/stock-out/page")
        ),
        permission: { entityType: "garageregister", action: "delete_vehicle" },
      },
    ],
  },
};

export const statusColors = {
  inProcess: "bg-primary ",
  received: "bg-white ",
  complete: "bg-success ",
  cancelled: "bg-destructive ",
  readyForCleanup: "bg-warning ",
  readyForService: "bg-warning ",
  duplicate: "bg-gray-500 ",
  stocked_in: "bg-[#B9CDE5] text-[#062C70]",
  stocked_out: "bg-[#FFE89C] ",
  delivered: "bg-[#B7F3C5] ",
  void: "bg-red-300 text-red-950",
} as const;

export const ROLES = [
  { label: "Developer", value: "Developer" },
  { label: "Designer", value: "Designer" },
  { label: "Manager", value: "Manager" },
  { label: "Analyst", value: "Analyst" },
  { label: "Specialist", value: "Specialist" },
];
